var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19866 3.86753L5.71241 7.32578C5.78907 7.40162 5.89256 7.44417 6.00041 7.44417C6.10825 7.44417 6.21174 7.40162 6.28841 7.32578L9.80216 3.86828C9.8793 3.79247 9.98313 3.74999 10.0913 3.74999C10.1994 3.74999 10.3033 3.79247 10.3804 3.86828C10.4184 3.90531 10.4486 3.94957 10.4692 3.99845C10.4898 4.04734 10.5004 4.09985 10.5004 4.1529C10.5004 4.20595 10.4898 4.25847 10.4692 4.30735C10.4486 4.35623 10.4184 4.40049 10.3804 4.43753L6.86741 7.89503C6.63601 8.12222 6.32469 8.24951 6.00041 8.24951C5.67612 8.24951 5.3648 8.12222 5.13341 7.89503L1.62041 4.43753C1.5823 4.40048 1.55202 4.35617 1.53134 4.30722C1.51066 4.25827 1.5 4.20567 1.5 4.15253C1.5 4.09939 1.51066 4.04678 1.53134 3.99783C1.55202 3.94888 1.5823 3.90457 1.62041 3.86753C1.69755 3.79172 1.80138 3.74924 1.90953 3.74924C2.01769 3.74924 2.12151 3.79172 2.19866 3.86753Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLine);
export default __webpack_public_path__ + "static/media/arrowDownLine.9086a538e05d37db138ded2b19b2669c.svg";
export { ForwardRef as ReactComponent };